import type { Account } from '@livecontrol/scheduler/model';
import type { ReactElement } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-top: var(--spacer-32px);
  padding-bottom: 40px;
  border-bottom: 1px solid #e4e8f0 !important;

  .plus {
    border-radius: 50%;
    border: 1px solid var(--primary) !important;
    padding: 0px 5px;
    font-size: 17px;
    font-weight: 100;
  }

  img {
    max-width: var(--spacer-24px);
  }
`;

export const PaymentMethod = ({ stripeURL }: { stripeURL?: string; expMonth?: Account.Billing['stripe']['expMonth'] }): ReactElement => (
  <Container>
    <h2 className='text-dark font-size-20px font-weight-bold'>Payment Method</h2>
    <div className='d-flex flex-row'>
      <div className='d-flex flex-column'>
        <a
          href={stripeURL ?? ''}
          target='_blank'
          rel='noopener noreferrer'
        >
          View or Update Payment Method
        </a>
      </div>
    </div>
  </Container>
);
